import {
  CLOSE_DRAWER,
  CLOSE_REMOVE_CONFIRM,
  CREATE_DESTINATION_ASYNC,
  DEACTIVATE_DESTINATION,
  DEACTIVATE_DESTINATION_DONE,
  DEACTIVATE_DESTINATION_LOADING,
  DELETE_DESTINATION_ASYNC,
  FETCH_DESTINATION_ASYNC,
  FETCH_DESTINATIONS_ASYNC,
  OPEN_DRAWER,
  OPEN_REMOVE_CONFIRM,
  UPDATE_DESTINATION_ASYNC,
} from './constants'

export const fetchDestinations = () => ({ type: FETCH_DESTINATIONS_ASYNC.INITIATE })
export const fetchDestinationsSuccess = (data) => ({
  type: FETCH_DESTINATIONS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDestinationsError = (error) => ({
  type: FETCH_DESTINATIONS_ASYNC.ERROR,
  error,
})

export const fetchDestination = (destinationId) => ({
  type: FETCH_DESTINATION_ASYNC.INITIATE,
  payload: { destinationId },
})
export const fetchDestinationSuccess = (data) => ({
  type: FETCH_DESTINATION_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDestinationError = (error) => ({
  type: FETCH_DESTINATION_ASYNC.ERROR,
  error,
})

export const createDestination = (destination) => ({
  type: CREATE_DESTINATION_ASYNC.INITIATE,
  payload: { destination },
})
export const createDestinationSuccess = () => ({
  type: CREATE_DESTINATION_ASYNC.SUCCESS,
})
export const createDestinationError = (error) => ({
  type: CREATE_DESTINATION_ASYNC.ERROR,
  error,
})

export const updateDestination = (destinationId, destination) => ({
  type: UPDATE_DESTINATION_ASYNC.INITIATE,
  payload: { destinationId, destination },
})
export const updateDestinationSuccess = () => ({
  type: UPDATE_DESTINATION_ASYNC.SUCCESS,
})
export const updateDestinationError = (error) => ({
  type: UPDATE_DESTINATION_ASYNC.ERROR,
  error,
})

export const deleteDestination = (destinationId) => ({
  type: DELETE_DESTINATION_ASYNC.INITIATE,
  payload: { destinationId },
})
export const deleteDestinationSuccess = () => ({
  type: DELETE_DESTINATION_ASYNC.SUCCESS,
})
export const deleteDestinationError = (error) => ({
  type: DELETE_DESTINATION_ASYNC.ERROR,
  error,
})

export const deactivateDestination = (destinationId) => ({
  type: DEACTIVATE_DESTINATION,
  payload: { destinationId },
})
export const deactivateDestinationLoading = () => ({ type: DEACTIVATE_DESTINATION_LOADING })
export const deactivateDestinationDone = () => ({ type: DEACTIVATE_DESTINATION_DONE })

export const openDrawer = (mode, destinationId = null, initialData = null) => ({
  type: OPEN_DRAWER,
  payload: { mode, destinationId, initialData },
})
export const closeDrawer = () => ({ type: CLOSE_DRAWER })

export const openRemoveConfirm = (destinationId) => ({
  type: OPEN_REMOVE_CONFIRM,
  payload: { destinationId },
})
export const closeRemoveConfirm = () => ({ type: CLOSE_REMOVE_CONFIRM })

export default {
  fetchDestinations,
  createDestination,
  updateDestination,
  deactivateDestination,
  deactivateDestinationLoading,
  deactivateDestinationDone,
  deleteDestination,
  openDrawer,
  closeDrawer,
  openRemoveConfirm,
  closeRemoveConfirm,
}
